import { FileCardWithPreviewProps } from './Types'
import { ContentTypeCardLink } from 'screens/blaze/Home/components/Catalogue/components/ContentTypeCard/ContentTypeCard'

export const FileCard = ({ file, preview: Preview, icon, ...props }: FileCardWithPreviewProps) => {
  const { title, url } = file

  return <ContentTypeCardLink icon={icon} preview={() => <Preview file={file} />} title={title} to={url} {...props} />
}
